
import { withAxios } from 'op/components/auth';
import Remarks from 'op/components/remarks';
import React from 'react';
import { hot } from 'react-hot-loader';
import { compose } from 'recompose';
import { Card, Icon, Image } from 'semantic-ui-react';
import styled from 'styled-components';
import StpBlack from '../../../assets/stp-black.svg';
import CardWrapper from './card-wrapper';
import { withItemSelection } from './info-card.helper';

const ItemDisplay = ({ item, axios }) => {
	return (
		<CardWrapper>
			<Card className='item-info'>
				<Card.Content>
					<Card.Header>
						{item.item_Name} / {item.item_ID}
					</Card.Header>
					<Card.Description>
						<strong>Serial number:</strong> {item.item_Serial} <br />
						<strong>Model:</strong> {item.item_Model} <br />
						<strong>Location:</strong> {item.item_Location}
					</Card.Description>
				</Card.Content>
			</Card>
		</CardWrapper>
	)
};

export default compose(
	withItemSelection,
	hot(module),
	withAxios
)(ItemDisplay);